export default __webpack_public_path__ + "static/orangeguyballoon-38a498ebd01da850bac6410b1b915ff4.svg";